<template>
    <div id="simple-calendar-app">
        <div class="no-scroll-content">
            <calendar-view
            ref="calendar"
            :displayPeriodUom="calendarView"
            :show-date="showDate"
            :events="events"
            :eventTop="windowWidth <= 400 ? '2rem' : '3rem'"
            eventBorderHeight="0px"
            eventContentHeight="1.65rem"
            class="theme-default"
            :startingDayOfWeek="startingDayOfWeek"
            locale="PT"
            @click-event="openEvent">

                <div slot="header" class="mb-4">

                    <div class="vx-row no-gutter">

                        <!-- Month Name -->
                        <div class="vx-col w-1/3 items-center sm:flex hidden">
                        </div>

                        <!-- Current Month -->
                        <div class="vx-col sm:w-1/3 w-full sm:my-0 my-3 flex justify-center order-last">
                            <div class="flex items-center">
                                <feather-icon
                                  :icon="$vs.rtl ? 'ChevronRightIcon' : 'ChevronLeftIcon'"
                                  @click="updateMonth(-1)"
                                  svgClasses="w-5 h-5 m-1"
                                  class="cursor-pointer bg-primary text-white rounded-full" />

                                <span class="mx-3 text-xl font-medium whitespace-no-wrap">{{ showDateView }}</span>

                                <feather-icon
                                  :icon="$vs.rtl ? 'ChevronLeftIcon' : 'ChevronRightIcon'"
                                  @click="updateMonth(1)"
                                  svgClasses="w-5 h-5 m-1"
                                  class="cursor-pointer bg-primary text-white rounded-full" />
                            </div>
                        </div>

                        <div class="vx-col sm:w-1/3 w-full flex justify-center">
                            <template v-for="(view, index) in calendarViewTypes">
                                <vs-button
                                  v-if="calendarView === view.val"
                                  :key="String(view.val) + 'filled'"
                                  type="filled"
                                  class="p-3 md:px-8 md:py-3"
                                  :class="{'border-l-0 rounded-l-none': index, 'rounded-r-none': calendarViewTypes.length !== index+1}"
                                  @click="calendarView = view.val"
                                  >{{ view.label }}</vs-button>
                                <vs-button
                                  v-else
                                  :key="String(view.val) + 'border'"
                                  type="border"
                                  class="p-3 md:px-8 md:py-3"
                                  :class="{'border-l-0 rounded-l-none': index, 'rounded-r-none': calendarViewTypes.length !== index+1}"
                                  @click="calendarView = view.val"
                                  >{{ view.label }}</vs-button>
                            </template>

                        </div>
                    </div>

                    <div class="vx-row sm:flex hidden mt-4">
                        <div class="vx-col w-full flex">
                            <!-- Labels -->
                            <div class="flex flex-wrap sm:justify-start justify-center">
                                <div v-for="(category, index) in categories" :key="index" class="flex items-center mr-4 mb-2">
                                    <div class="h-3 w-3 inline-block rounded-full mr-2" :style="'background-color:' + category.color"></div>
                                    <span>{{ category.name }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </calendar-view>
        </div>

        

        <!-- POPUP EVENT -->
        <vs-popup
            id="calendar-event-dialog-show-homepage"
            class="calendar-event-dialog"
            :title="title"
            :active.sync="activePopupEvent">

            <p v-if="type == 'ANIVERSARIO'">
                <vs-list v-for="(element, index) in list" :key="index">

                    <vs-list-header :title="index" ></vs-list-header>
                    <vs-list-item v-for="(person, key) in element" :key="key" :title="person.name" :subtitle="person.department"></vs-list-item>

                </vs-list>
            </p>
            <div v-else>
                <QuillPresentInfo v-bind:info="description"></QuillPresentInfo>
            </div>

        </vs-popup>
    </div>
</template>

<script>
import { CalendarView, CalendarViewHeader } from 'vue-simple-calendar'
import moduleCalendar from '@/store/calendar/moduleCalendar.js'
require('vue-simple-calendar/static/css/default.css')

import QuillPresentInfo from '@/views/components/QuillPresentInfo.vue'

import Datepicker from 'vuejs-datepicker'
import { en, he } from 'vuejs-datepicker/src/locale'

export default {
    components: {
        CalendarView,
        CalendarViewHeader,
        Datepicker,
        QuillPresentInfo,
    },
    data () {
        return {
            categories: [],
            events: [],

            showDate: new Date(),
            showDateView: '',

            id: 0,
            event_category_id: 0,
            hotel_id: 0,
            title: '',
            description: '',
            list: [],
            startDate: '',
            endDate: '',
            url: '',
            type: '',

            activePopupEvent: false,


            startingDayOfWeek: 1,
            calendarView: 'month',
            calendarViewTypes: [
                {
                    label: 'Mês',
                    val: 'month'
                },
                {
                    label: 'Semana',
                    val: 'week'
                }
            ]
        }
    },
    computed: {
        windowWidth () {
          return this.$store.state.windowWidth
        }
    },
    methods: {
        getEvents(date_month = ''){
            this.$vs.loading();

            if(date_month == ''){
                var date_m = '';
            }else{
                var year = date_month.getFullYear();
                var month = date_month.getMonth()+1;
                var day = date_month.getDate();
                var date_m = year+'-'+month+'-'+day;
            }

            var hotel = '';

            if(date_month != null){
                hotel = this.$user.staff_info.hvg_id;
            }

            this.$api({
                method: 'get',
                url: '/myvilagale/event/getList',
                params: {
                    token: this.$user.usertoken,
                    date_month: date_m,
                    hotel: hotel
                },
            })
            .then((res) => {
                var response = res.data;
                var events_renamed = [];
                var count = 0;

                for (var i = 0; i < response.length; i++) {
                    count++;
                    if(response[i].type == 'EVENTO'){
                        events_renamed.push({
                            id: count,
                            event_category_id: response[i].event_category_id,
                            hotel_id: 0,
                            title: response[i].name,
                            description: response[i].description,
                            startDate: response[i].start_date,
                            endDate: response[i].end_date,
                            style: 'background-color:'+response[i].category.color,
                            type: response[i].type,
                        });
                    }else if(response[i].type == 'ANIVERSARIO'){
                        events_renamed.push({
                            id: count,
                            event_category_id: response[i].event_category_id,
                            hotel_id: 0,
                            title: 'Feliz Aniversário!',
                            description: response[i].type,
                            startDate: response[i].birthday,
                            endDate: response[i].birthday,
                            style: 'background-color:'+response[i].color,
                            type: response[i].type,
                        });
                    }else if(response[i].type == 'HOTEL'){
                        events_renamed.push({
                            id: count,
                            event_category_id: response[i].event_category_id,
                            hotel_id: response[i].hotel_id,
                            title: response[i].title,
                            description: response[i].type,
                            startDate: response[i].birthday,
                            endDate: response[i].birthday,
                            style: 'background-color:'+response[i].color,
                            type: response[i].type,
                        });
                    }
                    
                }
                this.$vs.loading.close();
 
                this.events = events_renamed;
            })
            .catch((err) => {
                this.notify(err.response.data.message, 'red', 10);
                this.$vs.loading.close();
            });
        },
        getCategories(date_month){
            this.$vs.loading();
            this.$api({
                method: 'get',
                url: '/myvilagale/event/getCategories',
                params: {
                    token: this.$user.usertoken
                },
            })
            .then((res) => {
                this.categories = res.data;
                this.$vs.loading.close();
            })
            .catch((err) => {
                this.notify(err.response.data.message, 'red', 10);
                this.$vs.loading.close();
            });
        },
        getTodayBirthdays(date_month){
            this.$vs.loading();
            this.$api({
                method: 'get',
                url: '/myvilagale/event/getTodayBirthdays',
                params: {
                    token: this.$user.usertoken,
                    date_month: date_month
                },
            })
            .then((res) => {
                this.$vs.loading.close();
                this.list = res.data;
                this.activePopupEvent = true;
            })
            .catch((err) => {
                this.notify(err.response.data.message, 'red', 10);
                this.$vs.loading.close();
            });
            
        },
        updateMonth (val) {
            var old_month = this.showDate.getMonth();
            this.showDate = this.$refs.calendar.getIncrementedPeriod(val);
            var new_month = this.showDate.getMonth();
            if(old_month !== new_month){
                this.getEvents(this.showDate);
                this.setShowDateView(this.showDate.getMonth(), this.showDate.getFullYear());   
            }
        },
        openEvent (event) {
            this.id = event.originalEvent.id;
            this.title = event.originalEvent.title;
            this.hotel_id = event.originalEvent.hotel_id;
            this.startDate = event.originalEvent.startDate;
            this.endDate = event.originalEvent.endDate;
            this.type = event.originalEvent.type;

            if(event.originalEvent.event_category_id != 1){
                this.description = event.originalEvent.description;
                this.activePopupEvent = true;
            }else{
                if(event.originalEvent.description == 'ANIVERSARIO'){
                    this.getTodayBirthdays(this.startDate);
                }else if(event.originalEvent.description == 'HOTEL'){
                    var artigo_definido = event.originalEvent.hotel_id == '103' ? 'a' : 'o';
                    this.description = 'Hoje, '+artigo_definido+' <span class="hotelText">'+event.originalEvent.title.toLowerCase()+'</span> está de Parabéns!\nUm obrigado especial a toda a equipa e votos de muito sucesso.\nFeliz Aniversário!';
                    this.activePopupEvent = true;
                }
            }
        },
        setShowDateView(month = null, year = null){
            const monthNames = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];
            if(month == null){
                var monthNumber = new Date().getMonth();
            }else{
                var monthNumber = month;
            }
            if(year == null){
                var yearNumber = new Date().getFullYear();
            }else{
                var yearNumber = year;
            }
            
            var monthName = monthNames[monthNumber];
            this.showDateView = monthName+' '+yearNumber;
        }
    },
    watch:{
        activePopupEvent: function(new_val, old_val){
            if(!new_val){
                this.list = [];
            }
        }
    },
    created () {
        this.getEvents();
        this.getCategories();
        this.setShowDateView();
    },
}
</script>

<style lang="scss">
    @import "@/assets/scss/vuesax/apps/simple-calendar.scss";
</style>

<style>
    .today{
        height: 2rem;
    }
    #calendar-event-dialog-show-homepage .pre{
        white-space: pre-wrap;
    }
    .hotelText{
        text-transform: capitalize;
    }
</style>
